import React from 'react'
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import {assignIn, get} from 'lodash'
import { render } from 'react-dom'
import App from './App'
import getQueryVariable from './tools/getQueryVariable'
import popup from './views/Popup/popup'
import { refreshUser, fetchUserSubscription, onUser } from './redux/user/helpers'
import initializeGtm from './tools/analytics/gtm'
import { capitalize } from './tools/utils'
import './assets/css/fix.css'
import './assets/css/base.scss'

import pageStore from './redux/page/store'
import userStore from './redux/user/store'
import { fetchPage } from './redux/page/actions'
import { initGa, initEnhancedECommerce } from './tools/analytics/googleAnalytics'
import { initCleverTap, addUserProfile } from './tools/analytics/cleverTap'
import { initializeWebWorker, requestUserPermission } from './tools/webWorker'
import { pushToDatalayer } from "~/tools/analytics/gtmDatalayer";
import './adobePass/adobePrimeCallbacks.js'
import initializeAccessEnabler from './adobePass/loadAccessEnabler'
import initFreshChatBot from './tools/analytics/freshChatBot'
import initFbEvent from './tools/analytics/fbEvent';
import { initGtmAdwords, initCookieBot } from './tools/analytics/gtmTags';

var location = window.location
var route = location.pathname
if (route.length > 1) route = route.replace(/\/$/, '')

var page = pageStore.getState()
if (!(page.data && page.data.route === route) && !page.fetchingPage)
	pageStore.dispatch(fetchPage(route))

if ((window && window.settings && window.settings.features && window.settings.features.enablePWA) && 'serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register("/serviceWorker.js")
			.then((reg) => {
				console.log('Service worker registered.', reg);
			});
	});
}
initGa()
initCleverTap()
window && window.settings && window.settings.features && window.settings.features.enablePWA && initializeWebWorker()
initGtmAdwords()
if (!window.SERVER_SIDE_RENDERING && window.sessionStorage && !window.sessionStorage.getItem('isApp')) {
	initCookieBot()
}

if(get(window.settings, 'serviceType') === 'TVE'){
	initializeAccessEnabler()
}

onUser((user) => {
	if (user && user.email) {
		pushToDatalayer('user_email', user.email);
	}
})

var setUserStatus = function(onPageLoad) {
	refreshUser().then(() => {
		var userInfo = userStore.getState().user || {}
		if (userInfo.userId) {
			var userProfileData = {
				'Name': userInfo.name,
				'Email': userInfo.email,
				'Identity': userInfo.userId,
				'Phone': userInfo && userInfo.phone ? JSON.parse(userInfo.phone) : "", 
				'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
				'registration_method': userInfo.provider,
				'registration_platform': userInfo.registerdVia && capitalize(userInfo.registerdVia.split('_')[0]),
				'registration_date': userInfo.registeredOn,
				'registration_country': userInfo.country,
			}
			if (userInfo.isSubscribed) {
				fetchUserSubscription().then(() => {
					assignIn(userInfo, userStore.getState().user)
					assignIn(userProfileData, {
						'paymentMode': userInfo.subscription.subscriptionInfo.cardType,
						'paymentHandler': userInfo.subscription.subscriptionInfo.paymentHandler,
						'subscriptionStartDate': userInfo.subscription.subscriptionInfo.subscriptionStartDate,
						'subscriptionEndDate': userInfo.subscription.subscriptionInfo.subscriptionEndDate,
						'transactionId': userInfo.subscription.subscriptionInfo.vlTransactionId,
						'discountAmount': userInfo.subscription.subscriptionInfo.planAmount,
						'paymentPlan': userInfo.subscription.subscriptionPlanInfo.name,
						'freeTrial': userInfo.subscription.subscriptionInfo.freeTrial ? 'Yes' : 'No',
						'country': userInfo.subscription.subscriptionInfo.countryCode,
						'currency': userInfo.subscription.subscriptionInfo.currencyCode,
						'amount': userInfo.subscription.subscriptionPlanInfo.planDetails[0].strikeThroughPrice,
					})
					addUserProfile('Site', userProfileData)
				})
			} else {
				addUserProfile('Site', userProfileData)
			}
			if (onPageLoad && window.settings.notifications && window.settings.notifications.enableWebPushNotification) {
				requestUserPermission()
			}
		} else {
			addUserProfile('Site', {
				'User Status': 'Anonymous'
			})
		}
	})
}

if (window.settings.serviceType === 'SVOD') {
	initEnhancedECommerce()
	setUserStatus(true);
 	//checking on the page load
	const duration = (window && window.localStorage.token && JSON.parse(window.localStorage.token).duration) || 1800000;	//Time Interval fetched from token expiration | Validity of auth token
	setInterval(() => setUserStatus(), duration); //refreshing the user after a fixed time interval | Default is 1800000ms or 30mins
}

var plans = getQueryVariable('forwardParams')
var app = getQueryVariable('app')
const params = new URLSearchParams(window.location.search)
const offerCode = params.get('offer')
if (offerCode) {
	window.sessionStorage.setItem('offer', offerCode)
}
if (app) {
	window.sessionStorage.setItem('isApp', true)
}
if (plans) {
	const plans = params.get('forwardParams')
	window.sessionStorage.setItem('plans', plans.split('=')[1])
}
var popupName = getQueryVariable('popup')
if (popupName && popup[popupName]) popup[popupName]()

render(<App />, document.getElementById('root'))
initializeGtm()
initFreshChatBot()
initFbEvent()